module.exports = __webpack_public_path__ + "files/rexmid.e7e254998b92e08970e1ff4f841c0900.pdf";